export enum ComputeNodeConstructorMode {
  EDIT = "edit",
  ACTION_EDIT = "action_edit",
  READONLY = "readonly",
  ACTION = "action",
}
